import { getColorScheme } from "@appally/lib/utils/colorSchemes";
import { progressAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(progressAnatomy.keys);

const solid = definePartsStyle((props) => {
  const { main, dark, light, tint } = getColorScheme(props.colorScheme);
  return {
    track: {
      bg: tint,
      _dark: {
        bg: "gray.950",
      },
    },
    filledTrack: {
      bg: main,
      rounded: "full",
    },
  };
});

const block = definePartsStyle((props) => {
  const { main, dark, light, tint } = getColorScheme(props.colorScheme);
  return {
    track: {
      bg: tint,
      rounded: "2xl",
    },
    filledTrack: {
      bg: main,
      rounded: "2xl",
    },
  };
});

const gradient = definePartsStyle((props) => {
  const { main, dark, tint } = getColorScheme(props.colorScheme);
  return {
    track: {
      bg: `gray.200`,
    },
    filledTrack: {
      bgGradient: `linear(to-r, ${tint}, ${dark})`,
    },
  };
});

const bubble = definePartsStyle((props) => {
  const { main, dark, tint } = getColorScheme(props.colorScheme);
  return {
    track: {
      bg: "gray.100",
    },
    filledTrack: {
      bg: props.colorScheme,
      rounded: "full",
      // minWidth: "10%",
    },
  };
});

export const Progress = defineMultiStyleConfig({
  variants: { solid, block, gradient, bubble },
  baseStyle: {
    border: 0,
    track: {
      rounded: "full",
    },
    filledTrack: {
      transition: "all 0.3s",
    },
  },
  defaultProps: {
    variant: "solid",
    colorScheme: "primary",
  },
});
